import React from 'react';
import { Link } from 'react-router-dom';

const Info = () => {
  return (
    // İŞTE DOĞRU YERLEŞİM BURASI: En dıştaki div etiketinin içine yazıldı
    <div className="fixed inset-0 w-full h-full overflow-y-auto bg-slate-50 z-50 pb-20">
      <div className="max-w-4xl mx-auto py-10 px-6 min-h-full">
        
        <div className="flex justify-between items-center mb-10 bg-white p-6 rounded-3xl shadow-sm border border-slate-100">
          <div>
            <h1 className="text-2xl font-black text-slate-900 uppercase italic tracking-tighter">Yararlı Bilgiler</h1>
            <p className="text-slate-400 text-xs font-bold uppercase tracking-widest">Afet anında yapılması gerekenler</p>
          </div>
          <Link to="/" className="bg-slate-800 text-white px-6 py-3 rounded-xl font-bold text-sm shadow-lg active:scale-95 transition-all">
            Haritaya Dön
          </Link>
        </div>

        <div className="space-y-6">
          <div className="bg-white p-8 rounded-[32px] shadow-sm border border-slate-100">
            <h3 className="text-lg font-black text-red-600 mb-4 uppercase italic">🔥 Orman Yangını Görürseniz</h3>
            <p className="text-slate-600 leading-relaxed font-medium">
              Hemen güvenli bir alana uzaklaşın ve sistemimiz üzerinden konumu bildirin. Rüzgarın yönüne dikkat edin ve asla alevlere doğru ilerlemeyin. 
              Mümkünse ekipler gelene kadar ana yolların açık kalmasını sağlayın.
            </p>
          </div>

          <div className="bg-white p-8 rounded-[32px] shadow-sm border border-slate-100">
            <h3 className="text-lg font-black text-slate-800 mb-4 uppercase italic">📱 Uygulama Kullanımı</h3>
            <p className="text-slate-600 leading-relaxed font-medium">
              Sistemimiz konumunuzu otomatik olarak GPS üzerinden alır. İhbar yaparken mutlaka fotoğraf veya video ekleyiniz. 
              Yapay zeka ve ekiplerimiz bu görseller üzerinden doğruluğu teyit etmektedir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;